import { useCartMode } from '../lib/cartModes';
import { useSelector } from 'react-redux';
import { isBundleCartItem } from '../lib/cart';

export default function useGiftCart() {
  const { cartSelector } = useCartMode();
  const cart = useSelector(cartSelector);

  const isAllGifts = Object.values(cart.cartItems).every((item) => {
    return isBundleCartItem(item) ? item.isGift : false;
  });

  // Cart contains some gifts, but other regular items as well.
  // Show regular checkout flow with some extra disclaimers.
  const isOnlySomeGifts =
    Object.values(cart.cartItems).some((item) => {
      return isBundleCartItem(item) ? item.isGift : false;
    }) && !isAllGifts;

  return { isAllGifts, isOnlySomeGifts };
}
